import React from "react";
import DrawerComponent from "../../components/Drawers/drawers";
import { useSelector } from "react-redux";
import { ContentCopy } from "@mui/icons-material";
import toast from "react-hot-toast";
import ActivityLog from "./ActivityLog";
import moment from "moment";

const StockSummaryDrawer = ({
  showStockSummaryDrawer,
  setShowStockSummaryDrawer,
  locationId,
}) => {
  const { stockStatusByStore } = useSelector((state) => state.inventory);

  const product = stockStatusByStore.find(
    (item) => String(item.stock_id) === String(locationId)
  );

  const handleCopyNumber = (number) => {
    navigator.clipboard.writeText(number);
    toast.success(`${number} copied successfully`);
  };

  // Function to get expiry date styling based on time remaining
  const getExpiryDateStyling = (expiryDate) => {
    if (!expiryDate) return { color: "#5F6D60", borderColor: "#E1E6E1" };

    const today = moment();
    const expiry = moment(expiryDate);
    const daysUntilExpiry = expiry.diff(today, "days");

    if (daysUntilExpiry <= 7) {
      // Red for 1 week or less
      return { color: "#B92020", borderColor: "#B92020" };
    } else if (daysUntilExpiry <= 30) {
      // Amber for 1 month or less
      return { color: "#D4A407", borderColor: "#D4A407" };
    } else {
      // Green for longer than 1 month
      return { color: "#2B8C34", borderColor: "#2B8C34" };
    }
  };

  return (
    <DrawerComponent
      show={showStockSummaryDrawer}
      showDrawer={setShowStockSummaryDrawer}
      paddingAllowed={false}
      title={"Stock Summary"}
    >
      <div className="flex flex-col h-full overflow-hidden border-t border-[#E1E6E1]">
        <div className="bg-white py-4 px-6">
          <div className="border rounded-md border-[#E1E6E1]">
            {/* Stock Info */}
            <div className="flex justify-between px-3 py-2 items-center  ">
              <p className="text-[#3E473F] font-semibold text-sm">Stock Info</p>

              {product?.stock_id ? (
                <div className="border border-[#E1E6E1] px-1 py-1 rounded bg-white w-fit gap-0.5 flex items-center text-xs text-[#5F6D60] font-semibold">
                  {product?.stock_id}
                  <ContentCopy
                    className="text-[#5F6D60] cursor-pointer"
                    style={{ fontSize: "10px" }}
                    onClick={() => handleCopyNumber(product?.stock_id)}
                  />
                </div>
              ) : (
                "---"
              )}
            </div>
            {/* Store */}
            <div className="flex">
              <div className="w-[30%] flex flex-col justify-center px-3 py-2 bg-[#F6F7F6] border-r border-t border-[#E1E6E1] text-[#5F6D60] font-semibold text-xs">
                <p>Store</p>
              </div>
              <div className="w-[70%] px-3 py-2 bg-white border-t  border-[#E1E6E1] text-[#5F6D60] font-semibold text-xs">
                <p className="border border-[#E1E6E1] px-1 py-1 rounded bg-white w-fit">
                  {product?.location_name}
                </p>
              </div>
            </div>
            {/* Current Stock */}
            <div className="flex">
              <div className="w-[30%] flex flex-col justify-center px-3 py-2 bg-[#F6F7F6] border-r border-t border-[#E1E6E1] text-[#5F6D60] font-semibold text-xs">
                <p>Current Stock</p>
              </div>
              <div className="w-[70%] px-3 py-2 bg-white border-t border-[#E1E6E1] text-[#5F6D60] font-semibold text-xs">
                <p className="border border-[#E1E6E1] px-1 py-1 rounded bg-white w-fit">
                  {product?.current_stock}
                </p>
              </div>
            </div>
            {/* Cost Price */}
            <div className="flex">
              <div className="w-[30%] flex flex-col justify-center px-3 py-2 bg-[#F6F7F6] border-r border-t border-[#E1E6E1] text-[#5F6D60] font-semibold text-xs">
                <p>Cost Price</p>
              </div>
              <div className="w-[70%] flex justify-between px-3 py-2 bg-white border-t border-[#E1E6E1] text-[#5F6D60] font-semibold text-xs">
                <p className="border border-[#E1E6E1] px-1 py-1 rounded bg-white w-fit">
                  ₦{product?.cost_price?.toLocaleString()}
                </p>
                <div className="flex items-center gap-2">
                  Selling price:{" "}
                  <p className="border border-[#E1E6E1] px-1 py-1 rounded bg-white w-fit">
                    ₦{product?.selling_price?.toLocaleString()}
                  </p>
                </div>
              </div>
            </div>
            {/* Source STK ID */}
            <div className="flex">
              <div className="w-[30%] flex flex-col justify-center px-3 py-2 bg-[#F6F7F6] border-r border-t border-[#E1E6E1] text-[#5F6D60] font-semibold text-xs">
                <p>Source STK ID</p>
              </div>
              <div className="w-[70%] px-3 py-2 bg-white border-t  text-[#5F6D60] font-semibold text-xs">
                {product?.source_stock_id ? (
                  <div className="border border-[#E1E6E1] px-1 py-1 rounded bg-white w-fit gap-0.5 flex items-center text-xs text-[#5F6D60] font-semibold">
                    {product?.source_stock_id}
                    <ContentCopy
                      className="text-[#5F6D60] cursor-pointer"
                      style={{ fontSize: "10px" }}
                      onClick={() => handleCopyNumber(product?.source_stock_id)}
                    />
                  </div>
                ) : (
                  "---"
                )}
              </div>
            </div>

            {/* Expiry Date */}
            <div className="flex">
              <div className="w-[30%] flex flex-col justify-center px-3 py-2 bg-[#F6F7F6] border-t  border-r border-[#E1E6E1] text-[#5F6D60] font-semibold text-xs">
                <p>Expiry Date</p>
              </div>
              <div className="w-[70%] px-3 py-2 bg-white border-t font-semibold text-xs flex justify-between items-center">
                <p
                  className="px-1 py-1 rounded bg-white w-fit border"
                  style={{
                    color: getExpiryDateStyling(product?.expiry_date).color,
                    borderColor: getExpiryDateStyling(product?.expiry_date)
                      .borderColor,
                  }}
                >
                  {product?.expiry_date}
                </p>

                <p
                  style={{
                    color: getExpiryDateStyling(product?.expiry_date).color,
                  }}
                >
                  {moment(product?.expiry_date).fromNow()}
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* Activity Log */}
        <div className="">
          <ActivityLog stockId={product?.stock_id} maxHeight="450px" />
        </div>
      </div>
    </DrawerComponent>
  );
};

export default StockSummaryDrawer;
